export enum ClientStorageItem {
  coupleName = "coupleName",
  CurrentPage = "currentPage",
  AccessToken = "accessToken",
  XAccountHash = "xAccountHash",
  ShowOnboarding = "showOnboarding",
  HasSeenWelcome = "hasSeenWelcome",
  UserWeddingRole = "userWeddingRole",
  HasSeenDashboard = "hasSeenDashboard",
  ChakraUIColorMode = "chakra-ui-color-mode",
  CloudflareExpiresAt = "cloudflareExpiresAt",
  CloudflareBatchToken = "cloudflareBatchToken",
  HasCompletedDashboardSetup = "hasCompletedDashboardSetup",
}

export const ClientStorage = {
  store(item: ClientStorageItem, value: string) {
    localStorage.setItem(item, value);
  },
  fetch<T extends string>(item: ClientStorageItem) {
    return localStorage.getItem(item) as T;
  },
  delete(item: ClientStorageItem) {
    return localStorage.removeItem(item);
  }
};
